import React from "react";
import Aside from "../components/Aside/Aside";
import BlogList from "../components/Blog/BlogList";

const Home = () => {
  return (
    <>
      <section className="wrapper">
        <Aside />
        <BlogList />
      </section>
    </>
  );
};

export default Home;
